import { render, staticRenderFns } from "./PopTips.vue?vue&type=template&id=1d3eac7f&scoped=true&"
import script from "./PopTips.vue?vue&type=script&lang=js&"
export * from "./PopTips.vue?vue&type=script&lang=js&"
import style0 from "./PopTips.vue?vue&type=style&index=0&id=1d3eac7f&prod&lang=scss&scoped=true&"
import style1 from "./PopTips.vue?vue&type=style&index=1&id=1d3eac7f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3eac7f",
  null
  
)

export default component.exports